/**
 * Header Drawer — mobile navigation with overlay sub-panels.
 * Sub-panels slide over from right on top of current content.
 */
import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

class HeaderDrawer extends DialogComponent {
  /** @type {string[]} */
  #panelHistory = [];

  connectedCallback() {
    super.connectedCallback();
    // Reset panels when dialog closes (catches all close triggers)
    this.addEventListener(DialogCloseEvent.eventName, () => this.#resetPanels());
  }

  /**
   * Open a sub-panel overlay
   * @param {Event} event
   */
  openPanel(event) {
    const button = event.target instanceof Element
      ? event.target.closest('[data-target]')
      : null;
    if (!button) return;

    const targetId = button.dataset.target;
    const panel = document.getElementById(targetId);
    if (!panel) return;

    this.#panelHistory.push(targetId);
    panel.classList.add('is-active');
    panel.removeAttribute('aria-hidden');
  }

  /**
   * Go back — close top-most sub-panel with reverse animation
   */
  goBack() {
    const currentId = this.#panelHistory.pop();
    if (!currentId) return;

    const panel = document.getElementById(currentId);
    if (!panel) return;

    panel.classList.remove('is-active');
    panel.classList.add('is-closing');

    panel.addEventListener('animationend', () => {
      panel.classList.remove('is-closing');
      panel.setAttribute('aria-hidden', 'true');
    }, { once: true });
  }

  #resetPanels() {
    this.#panelHistory = [];
    this.querySelectorAll('.header-drawer__panel--sub').forEach((p) => {
      p.classList.remove('is-active', 'is-closing');
      p.setAttribute('aria-hidden', 'true');
    });
  }
}

if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HeaderDrawer);
}